/**
 * Iter 632 — customer wizard split: shared constants + tiny helpers
 * (moved verbatim from EngageSessionPanel.jsx).
 */
import { useEffect, useState } from "react";

export const ENGAGEMENT_HEADERS = { "X-App-Platform": "nz_classified" };
export const ENGAGEMENT_PARAM = { platform: "nz_classified" };
export const OPTS = { headers: ENGAGEMENT_HEADERS, params: ENGAGEMENT_PARAM };

export function money(n) {
  const v = Number(n);
  if (!Number.isFinite(v)) return null;
  return `$${Math.abs(v).toFixed(2)}`;
}

export function errDetail(err, fallback) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (typeof d?.message === "string" && d.message.trim()) return d.message;
  return fallback;
}

// Iter-562 §5 — remember the last claimed session so the site-wide
// BackToSessionRibbon can offer "Back to your session at {store}".
export function rememberSession(qrCodeId, data) {
  try {
    localStorage.setItem(
      "engage_last_session",
      JSON.stringify({ qr: qrCodeId, store: data?.vendor?.business_name || null, at: Date.now() }),
    );
  } catch {
    // private mode
  }
}

export function useCountdown(expiresAt) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  if (!expiresAt) return { label: null, expired: false };
  const ms = new Date(expiresAt).getTime() - now;
  if (!Number.isFinite(ms)) return { label: null, expired: false };
  // Iter-357 — never render a dead 0:00 countdown: at zero the timer
  // disappears (session refresh/recovery handles the expiry itself).
  if (ms <= 0) return { label: null, expired: true };
  // Don't render a nonsense countdown for far-future expiries.
  if (ms > 24 * 60 * 60 * 1000) return { label: null, expired: false };
  const totalS = Math.floor(ms / 1000);
  const m = Math.floor(totalS / 60);
  const s = totalS % 60;
  // Iter-326 — 3-hour session TTL: an hours-long countdown reads better
  // as "2 h 59 m" than "179:59"; m:ss kicks in under the final hour.
  if (m >= 60) return { label: `${Math.floor(m / 60)} h ${m % 60} m`, expired: false };
  return { label: `${m}:${String(s).padStart(2, "0")}`, expired: false };
}
